/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { formatChangedAt } from '../../utils/format-date'
import { getNoteLabel } from '../note-tree/build-note-tree'
import type { NoteTreeEntryInterface } from '@hedgedoc/commons'
import Link from 'next/link'
import React from 'react'
import { ListGroup } from 'react-bootstrap'
import { buildNoteUrl } from '../../utils/note-url'

export interface RecentNotesListProps {
  notes: NoteTreeEntryInterface[]
  /** Whether the folder of each note is shown */
  showPath?: boolean
}

/**
 * Renders a list of links to notes with the time they were last changed.
 */
export const RecentNotesList: React.FC<RecentNotesListProps> = ({ notes, showPath = false }) => {
  return (
    <ListGroup variant={'flush'}>
      {notes.map((note) => (
        <ListGroup.Item
          key={note.primaryAlias}
          action
          as={Link}
          href={buildNoteUrl(note.primaryAlias)}
          className={'d-flex justify-content-between align-items-baseline gap-3'}>
          <span className={'text-truncate'}>
            {note.badge && <span className={'me-2'}>{note.badge}</span>}
            {getNoteLabel(note)}
            {showPath && note.path && <small className={'text-body-secondary ms-2'}>{note.path}</small>}
          </span>
          <small className={'text-body-secondary text-nowrap'}>{formatChangedAt(note.lastChangedAt)}</small>
        </ListGroup.Item>
      ))}
    </ListGroup>
  )
}
